import Box from '@/common/components/Box'
import { ErrorMessageWrapper } from '@/common/components/ErrorMessageWrapper'
import GoBackButton from '@/common/components/GoBackButton'
import Skeleton from '@/common/components/Skeleton'
import { Contract } from '@/features/establishments/components/contract'
import useEstablishmentCompany from '@/features/establishments/hooks/useEstablishmentCompany'
import { ChevronsRightIcon } from 'lucide-react'
import { useParams } from 'react-router-dom'

const Show = () => {
  const { establishmentId } = useParams()

  const {
    data: establishment,
    error: establishmentError = {} as any,
    refetch: refetchEstablishment,
    isPending: establishmentIsPending,
  } = useEstablishmentCompany(establishmentId || '')

  return (
    <div className="inner-screen">
      <div className="flex justify-between items-center mb-6">
        <div className="flex gap-1 items-center">
          <GoBackButton fallback={`/establishments/${establishmentId}`} searchLastRouteFromFallback />
          {establishmentIsPending ? (
            <Skeleton width={320} height={24} />
          ) : (
            <h2 className="text-white-400">{establishment?.general_information?.fantasy_name}</h2>
          )}
          <ChevronsRightIcon strokeWidth={1} size={32} className="text-white-400" />
          <h2>Contrato</h2>
        </div>
      </div>

      <ErrorMessageWrapper
        className="flex-1"
        statusCode={establishmentError?.status}
        refetchFunction={refetchEstablishment}
      >
        <Box className="flex flex-col gap-y-6 overflow-y-auto flex-1">
          {establishment?.current_contract_id && (
            <Contract title="Contrato (CA)" id={establishment?.current_contract_id} />
          )}

          {establishment?.maintenance_contract_id && (
            <Contract title="Contrato (CM)" id={establishment?.maintenance_contract_id} showFeeDetails={false} />
          )}
        </Box>
      </ErrorMessageWrapper>
    </div>
  )
}

export default Show
